module.exports = __webpack_public_path__ + "static/Solution_Ad1-6eae08f2e5dcfbcc12a3aa6821b6247f.png";